import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import UsersLayout from "../components/layouts/layout";
import Authenticated from "../../../utils/Authenticated";

import { MODES_OPTIONS } from "../../../types/generics.types";
import UsersList from "../../users/users";
import EditUser from "../../users/editUser";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "./helpers";

const routesUsers: RouteObject = {
  path: pathRoutes.ADMIN_USUARIOS,
  element: (
    <>
      <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
        <UsersLayout />
      </PrivateRoutes>
    </>
  ),
  children: [
    {
      index: true,
      element: (
        <Authenticated>
          <UsersList />
        </Authenticated>
      ),
    },
    {
      path: "editar/:idUser",
      element: (
        <Authenticated>
          <EditUser mode={MODES_OPTIONS.EDIT} />
        </Authenticated>
      ),
    },
    {
      path: "ver/:idUser",
      element: (
        <Authenticated>
          <EditUser mode={MODES_OPTIONS.VIEW} />
        </Authenticated>
      ),
    },
    {
      path: "nuevo",
      element: (
        <Authenticated>
          <EditUser mode={MODES_OPTIONS.NEW} />
        </Authenticated>
      ),
    },
  ],
};

export default routesUsers;
